import { render, staticRenderFns } from "./LogicalAxiomeMaxQualifiedCardinality.vue?vue&type=template&id=fd28f8f8"
import script from "./LogicalAxiomeMaxQualifiedCardinality.vue?vue&type=script&lang=js"
export * from "./LogicalAxiomeMaxQualifiedCardinality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports